import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useWizard } from 'react-use-wizard';
import get from 'lodash/get';
import { Flex } from 'nallian-shared-ui/lib/components';
import { Text } from 'nallian-shared-ui/lib/layout/styles';
import CompleteOrganisationForm from './CompleteOrganisationForm';
import { ORGANISATION_STATES } from '../../../../app/constants';

const CompleteOrganisation = ({ invitationFetch, setData }) => {
  const { t } = useTranslation();
  const { nextStep } = useWizard();

  useEffect(() => {
    const organisationState = get(invitationFetch.value, 'organisation.activeStateId');
    if (organisationState === ORGANISATION_STATES.ACTIVE) {
      nextStep();
    }
  }, [invitationFetch.value, nextStep]);

  return (
    <Flex fluid direction="column">
      <Text>{t('pleaseCompleteOrganisationDetails')}</Text>
      <CompleteOrganisationForm
        initialValues={get(invitationFetch.value, 'organisation')}
        setData={setData}
      />
    </Flex>
  );
};

CompleteOrganisation.propTypes = {
  setData: PropTypes.func.isRequired,
  invitationFetch: PropTypes.object.isRequired,
};

export default CompleteOrganisation;
